import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { getLanguageNameByCode } from '../ManualLanguageSelector/supportedLanguages';

interface LanguageChangeDividerProps {
  language: string;
  isManual: boolean;
}

const DividerContainer = styled(Box).attrs({
  align: 'center',
  my: '16px',
  width: '100%',
})``;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => theme.colors.lightLineDivider};
`;

const DividerContent = styled(Box).attrs({
  align: 'center',
  px: '12px',
})`
  gap: 8px;
`;

const LanguageChangeDivider = ({
  language,
  isManual,
}: LanguageChangeDividerProps) => {
  const languageName = getLanguageNameByCode(language);
  const message = isManual
    ? `Caller language changed to ${languageName}`
    : `Language auto detected as ${languageName}`;

  return (
    <DividerContainer
      data-name="language-change-divider"
      data-testid={`language-change-divider-${language}${isManual ? '-manual' : '-auto'}`}
    >
      <DividerLine />
      <DividerContent>
        <Text size="small" color="secondaryText">
          {message}
        </Text>
      </DividerContent>
      <DividerLine />
    </DividerContainer>
  );
};

export default LanguageChangeDivider;
